var map = {
	"./symbol_0.png": "7942",
	"./symbol_1.png": "2807",
	"./symbol_2.png": "d22c",
	"./symbol_3.png": "636a",
	"./symbol_4.png": "db1d",
	"./symbol_5.png": "7220",
	"./symbol_6.png": "106d",
	"./symbol_7.png": "8944",
	"./symbol_8.png": "3a21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f8d";